import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'

import WorkBookmark from './WorkBookmark'
import WorkSharing from './WorkSharing'
import WorkOptions from './WorkOptions'

import FaEye from 'react-icons/fa/eye'
import FaComments from 'react-icons/fa/comments'
import FaThumbs from 'react-icons/fa/thumbs-o-up'

@autobind
class WorkStats extends Component {
  render () {
    return (
      <section className='workStats'>
        {!this.props.loading && <div>
          <ul className='workStats__counters'>
            <li><FaEye /><span className='workStats__counter'>{this.props.number_of_views || 0} view{this.props.number_of_views > 1 ? 's' : ''}</span></li>
            <li><FaComments /><span className='workStats__counter'>{this.props.number_of_approved_comments || 0} comment{this.props.number_of_approved_comments > 1 ? 's' : ''}</span></li>
          </ul>
          <ul className='workStats__actions'>
            <li><WorkBookmark work={this.props} user={this.props.user} /></li>
            <li><WorkSharing work={this.props} user={this.props.user} /></li>
            <li><WorkOptions work={this.props} user={this.props.user} /></li>
          </ul>
        </div>}
      </section>
    )
  }
}

export default WorkStats

WorkStats.propTypes = {
  loading: PropTypes.bool,
  views_count: PropTypes.number,
  likes_count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  comments_count: PropTypes.number,
  user: PropTypes.object
}



// WEBPACK FOOTER //
// ./components/work/WorkStats.js